import React, { useEffect, useRef, useState } from 'react'
import { Button } from 'components/Common'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'

import AuthTemplate from 'components/Auth/AuthTemplate'
import AuthForm from 'components/Auth/AuthForm'
import accountActions from 'stores/Account/Actions'
import { getExternalLinks } from 'stores/Links/Select'

import { mergeStyles } from '@enlyt/helpers/mergeStyles'

import closeChatbot from 'helpers/closeChatbot'

import useMediaQuery from 'hooks/useMediaQuery'
import Modal from 'components/Modal'
import { localization } from './localization'

import themeStyles from './styles'
import { useTheme } from 'contexts/ThemeProvider'
import withLocalization from '@web/helpers/localizationUtils'

const SignIn = props => {
  const { theme } = useTheme()
  const defaultStyles = themeStyles(theme)
  const { t } = props
  const EMPTY_SPACE = ' '
  const [showModal, setShowModal] = useState(false)
  const loginInFlightRef = useRef(false)
  const styles = mergeStyles(defaultStyles, props.style)
  const [signUpUrl, setSignUpUrl] = useState(null)
  const links = useSelector(getExternalLinks)
  const { isMobile } = useMediaQuery()

  const onSignUp = link => {
    props.onSignUp(link)
  }
  const onSubmit = () => {
    if (loginInFlightRef.current) {
      return
    }

    loginInFlightRef.current = true
    Promise.resolve(props.loginWithRedirect()).catch(() => {
      loginInFlightRef.current = false
    })
  }

  useEffect(() => {
    const unlockLogin = event => {
      if (event.persisted) {
        loginInFlightRef.current = false
      }
    }

    window.addEventListener('pageshow', unlockLogin)
    return () => window.removeEventListener('pageshow', unlockLogin)
  }, [])

  const dispatch = useDispatch()
  const { i18n } = useTranslation()

  useEffect(() => {
    // If the browser has a window object
    // Monitor browser language changes and set system language
    if (typeof window !== 'undefined') {
      const userLanguage =
        (navigator.language || navigator.browserLanguage)
          .toLowerCase()
          .indexOf('es') !== -1
          ? 'es'
          : 'en'
      dispatch(accountActions.setSystemLng(i18n.language || userLanguage))
      closeChatbot('help-chatbot')
    } else {
      const userLanguage = i18n.language
      dispatch(accountActions.setSystemLng(userLanguage || 'en'))
    }
  }, [dispatch, i18n.language])

  useEffect(() => {
    if (links) {
      const signUpUrl = _.get(links, ['LoginAccess', 'UFD_Create_Account'])
      if (signUpUrl) {
        setSignUpUrl(signUpUrl)
      }
    }
  }, [links])

  return (
    <AuthTemplate style={styles.authTemplate}>
      <AuthForm
        style={styles.buttonSign(isMobile)}
        onSubmit={onSubmit}
        submitLabel={t('signIn')}
      >
        {' '}
        {
          <div style={styles.container}>
            <p style={styles.title}>{t('welcome')}</p>
            <p style={styles.subTitle}>{t('subTitle')}</p>
            <div style={styles.desc}>
              {t('getAccess')}&nbsp;
              <span
                onClick={() => setShowModal(true)}
                style={isMobile ? styles.link : styles.linkMt}
              >
                {t('learnMore')}
              </span>
            </div>
            <Modal
              size={'small'}
              requireAction
              header={EMPTY_SPACE}
              style={styles.modal}
              open={showModal}
              onClose={() => setShowModal(false)}
            >
              {t('learnMoreContent')}
            </Modal>
          </div>
        }
      </AuthForm>
      <Button
        disabled={!signUpUrl}
        onClick={() => {
          onSignUp(signUpUrl)
        }}
        style={styles.buttonCreateAccount(isMobile)}
      >
        {t('createAccount')}
      </Button>
    </AuthTemplate>
  )
}

export const SignInComponent = withLocalization(SignIn, localization)
